import React from 'react';

import ProgressBar from './ProgressBar/progress';
import InfoBar from './InfoBar/infoBar';

const sliderC = ({ startWeatherData, startWeatherDataDaily, startWeatherForecast }) => (
  <>
    <ProgressBar />
    <InfoBar
      startWeatherData={startWeatherData}
      startWeatherDataDaily={startWeatherDataDaily}
      startWeatherForecast={startWeatherForecast}
    />
  </>
);

export default sliderC;
